<div class="card card-default m-3">
  <div class="card-header">
    <div class="row">
      <div class="col-10 my-auto">
        <h3 class="card-title font-cust-blue">ติดตามสถานะ</h3>
      </div>
      <div class="col-2 text-right">
        <button class="btn btn-link" data-toggle="collapse" data-target="#status" aria-expanded="true"
          aria-controls="status">
          <span class="fa fa-lg fa-chevron-circle-up"></span>
        </button>
      </div>
    </div>
  </div>
  <!-- /.card-header -->
  <div class="card-body p-0 collapse show" id="status">
    <table id="tbStatus" style="width:100%" class="table table-bordered table-hover result-table">
      <thead>
        <tr>
          <th>เลขที่คำขอ</th>
          <th>ประเภทการติดตามสถานะ<br>(มุมมองผู้ฝาก)</th>
          <th>สถานะ (มุมมองผู้ฝาก)</th>
          <th>ประเภทคำขอ (มุมมองระบบ)</th>
          <!--<th>สถานะ DROS (มุมมองระบบ)</th> -->
          <th>วันที่ปรับปรุงสถานะ</th>
        </tr>
      </thead>
      <tbody>
      </tbody>
    </table>
  </div>

</div>

<div class="card card-default m-3">
  <div class="card-header">
    <div class="row">
      <div class="col-10 my-auto">
        <h3 class="card-title font-cust-blue">จำนวนเงินสุทธิที่ได้จากสถาบัน</h3>
      </div>
      <div class="col-2 text-right">
        <button class="btn btn-link" data-toggle="collapse" data-target="#total" aria-expanded="true"
          aria-controls="total">
          <span class="fa fa-lg fa-chevron-circle-up"></span>
        </button>
      </div>
    </div>
  </div>
  <!-- /.card-header -->
  <div class="card-body p-0 collapse show" id="total">
    <table id="tbRefund" style="width:100%" class="table table-bordered table-hover result-table">
      <thead>
        <tr>
          <th>ชื่อสถาบันการเงิน</th>
          <th>รหัสเลขที่ผู้ฝาก</th>
          <th>จำนวนเงินสุทธิที่ได้รับจากสถาบัน</th>
          <th>วันที่ปรับปรุงสถานะ</th>
        </tr>
      </thead>
      <tbody>
      </tbody>
    </table>
  </div>

</div>

<div class="card card-default m-3">
  <div class="card-header">
    <div class="row">
      <div class="col-10 my-auto">
        <h3 class="card-title font-cust-blue">รายละเอียดเงินคืน</h3>
      </div>
      <div class="col-2 text-right">
        <button class="btn btn-link" data-toggle="collapse" data-target="#refundDetail" aria-expanded="true"
          aria-controls="refundDetail">
          <span class="fa fa-lg fa-chevron-circle-up"></span>
        </button>
      </div>
    </div>
  </div>
  <!-- /.card-header -->
  <div class="card-body p-0 collapse show" id="refundDetail">
    <table id="tbDetail" style="width:100%" class="table table-bordered table-hover result-table">
      <thead>
        <tr>
          <th>ชื่อสถาบันการเงิน</th>
          <th>รหัสเลขที่ผู้ฝาก</th>
          <th>จำนวนเงินสุทธิที่ได้รับจากสถาบัน</th>
          <th>วันที่ปรับปรุงสถานะ</th>
        </tr>
      </thead>
      <tbody>
      </tbody>
    </table>
  </div>
</div>


<div class="card card-default m-3">
  <div class="card-header">
    <div class="row">
      <div class="col-10 my-auto">
        <h3 class="card-title font-cust-blue">สถานะการยื่น Agent Bank</h3>
      </div>
      <div class="col-2 text-right">
        <button class="btn btn-link" data-toggle="collapse" data-target="#statusBank" aria-expanded="true"
          aria-controls="statusBank">
          <span class="fa fa-lg fa-chevron-circle-up"></span>
        </button>
      </div>
    </div>
  </div>
  <!-- /.card-header -->
  <div class="card-body p-0 collapse show" id="statusBank">
    <table id="tbAgentBank" style="width:100%" class="table table-bordered table-hover result-table">
      <thead>
        <tr>
          <th>ประเภทลูกค้า</th>
          <th>รหัสบัตรประชาชน/เลขประจำตัวผู้เสียภาษี</th>
          <th>เลขที่รับเรื่อง</th>
          <th>สถานะยื่น</th>
          <th>วันที่ปรับปรุงสถานะ</th>
        </tr>
      </thead>
      <tbody>
      </tbody>
    </table>
  </div>

</div>

<div class="row mt-5 mb-3">
  <div class="col-12 text-center">
    <button class="btn btn-info" (click)="close()">ปิด</button>
  </div>
</div>

<!-- Modal status-->
<div class="modal fade" id="statusModal" tabindex="-1" role="dialog" aria-labelledby="statusModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="statusModalLabel">ติดตามสถานะคำขอ</h5>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-2 text-right">
            <label>เลขที่คำขอ</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm03.RequestedNo}}">
          </div>

          <div class="col-2 text-right">
            <label>ประเภทคำขอ</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm03.RequestType}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>ชื่อผู้ฝาก</label>
          </div>
          <div class="col-8">
            <input type="text" class="form-control" disabled value="{{contact.fullname}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 text-right two-row-lbl">
            <label>ชื่อขั้นตอน</label><br>
            <label>(สถานะ)</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm03.ProcessDefinition}}">
          </div>

        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>ผลการพิจารณา</label>
          </div>
          <div class="col-8">
            <input type="text" class="form-control" disabled value="{{crm03.StatusDefinition}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>เหตุผล</label>
          </div>
          <div class="col-8">
            <textarea class="form-control" rows="4" disabled>{{crm03.Reason}}</textarea>
          </div>
        </div>

        <!-- <div class="row mt-3">
          <div class="col-2 text-right">
            <label>ตอบ</label>
          </div>
          <div class="col-8">
            <textarea class="form-control" rows="4" disabled></textarea>
          </div>
        </div> -->
        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>เอกสารเพิ่ม</label>
          </div>
          <div class="col-8">
            <a  (click)="showPdf()"><i class="fa fa-file-pdf" style="cursor: pointer">{{crm03.FileName}}</i></a>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>วันที่ปรับปรุงสถานะ</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm03.ModifyDate}}">
          </div>

          <!-- <div class="col-2 text-right">
            <label>ผู้สร้างข้อมุล</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="Agent Bank ABC 01">
          </div> -->
        </div>

        <div class="row mt-5 mb-2">
          <div class="col-12 text-center">
            <button type="button" class="btn btn-info" data-dismiss="modal">ปิด</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal status-->
<div class="modal fade" id="crm04Modal" tabindex="-1" role="dialog" aria-labelledby="crm04ModalLabel" aria-hidden="true"
  data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="crm04ModalLabel">ติดตามสถานะการจ่ายเงิน</h5>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-2 text-right">
            <label>เลขที่คำขอ</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm04.RequestedNo}}">
          </div>

          <div class="col-2 text-right">
            <label>ประเภทคำขอ</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm04.RequestType}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>หมายเลขโทรศัพท์</label><br>
            <label>มือถือผู้ฝาก</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm04.MobileNo}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>ชื่อผู้ฝาก</label>
          </div>
          <div class="col-8">
            <input type="text" class="form-control" disabled value="{{contact.fullname}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>ช่องทางการจ่ายเงิน</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm04.PaymentTypeID}}">
          </div>

          <div class="col-2 text-right">
            <label>วันที่ส่งข้อมูล</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm04.TransferedDate}}">
          </div>

        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>รหัสธนาคารที่โอนเข้า</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm04.BankCode}}">
          </div>

          <div class="col-2 text-right">
            <label>รหัสสาขาที่โอนเข้า</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm04.BankBranchCode}}">
          </div>

        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>เลขที่บัญชี</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm04.BankAccountNo}}">
          </div>

          <div class="col-2 text-right">
            <label>วันที่เช็คออกจากธนาคาร</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm04.ChequeIssueDate}}">
          </div>

        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>หมายเลขเช็ค</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm04.ChequeNo}}">
          </div>

          <div class="col-2 text-right">
            <label>วันที่ออกเช็ค</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm04.ChequeDate}}">
          </div>

        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>ที่อยู่ในการจัดส่งเช็ค</label>
          </div>
          <div class="col-8">
            <input type="text" class="form-control" disabled value="{{crm04.ChequeAddress}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 text-right two-row-lbl">
            <label>รายละเอียดสถานะ</label><br>
            <label>(สถานะ)</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm04.StatusDescription}}">
          </div>

          <div class="col-2 text-right">
            <label>สถานะการจ่ายเงิน</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm04.TransferedStatus}}">
          </div>

        </div>

        <!-- <div class="row mt-3">
          <div class="col-2 text-right">
            <label>ผลการพิจารณา</label>
          </div>
          <div class="col-8">
            <input type="text" class="form-control" disabled value="{{crm03.DisplayMessage}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>เหตุผล</label>
          </div>
          <div class="col-8">
            <textarea class="form-control" rows="4" disabled>{{crm03.Reason}}</textarea>
          </div>
        </div> -->

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>เหตุผลการไม่อนุมัติจ่าย</label>
          </div>
          <div class="col-8">
            <textarea class="form-control" rows="4" disabled>{{crm04.Remark}}</textarea>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>เอกสารเพิ่ม</label>
          </div>
          <div class="col-8">
            <a  (click)="showPdf()"><i class="fa fa-file-pdf" style="cursor: pointer">{{crm03.FileName}}</i></a>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>วันที่ปรับปรุงสถานะ</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm04.ModifyDate}}">
          </div>

          <div class="col-2 text-right">
            <label>ผู้สร้างข้อมุล</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="System">
          </div>
        </div>

        <div class="row mt-5 mb-2">
          <div class="col-12 text-center">
            <button type="button" class="btn btn-info" data-dismiss="modal">ปิด</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal status-->
<div class="modal fade" id="crm05Modal" tabindex="-1" role="dialog" aria-labelledby="crm05ModalLabel" aria-hidden="true"
  data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="crm05ModalLabel">ติดตามสถานะคำขออุทธรณ์</h5>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-2 text-right">
            <label>เลขที่คำขอ</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm05.RequestedNo}}">
          </div>

          <div class="col-2 text-right">
            <label>ประเภทคำขอ</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm05.RequestType}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>ชื่อผู้ฝาก</label>
          </div>
          <div class="col-8">
            <input type="text" class="form-control" disabled value="{{contact.fullname}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>ชื่อขั้นตอน</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm05.ProcessDefinition}}">
          </div>

        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>ประเภทการแก้ไข</label>
          </div>
          <div class="col-8">
            <input type="text" class="form-control" disabled value="{{crm05.StatusDefinition}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>เหตุผลที่โต้แย้ง</label>
          </div>
          <div class="col-8">
            <input type="text" class="form-control" disabled value="{{crm05.ProcessStatusReason}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>จำนวนเงินที่ต้องการจ่ายคืน</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm05.Finallyreimbursible  | number: '.2'}}">
          </div>

          <div class="col-2 text-right two-row-lbl">
            <label>ผลการตรวจสอบ</label><br>
            <label>(สถานะ)</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm05.Result}}">
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>เอกสารเพิ่ม</label>
          </div>
          <div class="col-8">
            <a  (click)="showPdf()"><i class="fa fa-file-pdf" style="cursor: pointer">{{crm03.FileName}}</i></a>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>วันที่ปรับปรุงสถานะ</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm05.ModifyDate}}">
          </div>

          <div class="col-2 text-right">
            <label>ผู้สร้างข้อมุล</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="System">
          </div>
        </div>

        <div class="row mt-5 mb-2">
          <div class="col-12 text-center">
            <button type="button" class="btn btn-info" data-dismiss="modal">ปิด</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Modal Financial Institutions-->
<div class="modal fade" id="financialModal" tabindex="-1" role="dialog" aria-labelledby="financialModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="financialModalLabel">จำนวนเงินสุทธิที่ได้จากสถาบัน</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-2 text-right">
            <label>ชื่อสถาบันการเงิน</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{bankName}}">
          </div>

          <div class="col-2 text-right">
            <label>รหัสเลขที่ของผู้ฝาก</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{contactDros?.CRM06?.IDNo}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>ชื่อผู้ฝาก</label>
          </div>
          <div class="col-8">
            <input type="text" class="form-control" disabled value="{{contact.fullname}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>จำนวนเงินสุทธิที่ได้รับจากสถาบัน</label>
          </div>
          <div class="col-8">
            <input type="text" class="form-control" disabled value="{{contactDros?.CRM06?.NetReimbursible  | number: '.2' }}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>วันที่ปรับปรุงสถานะ</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="">
          </div>

          <div class="col-2 text-right">
            <label>ผู้สร้างข้อมูล</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="">
          </div>
        </div>

        <div class="row mt-5 mb-2">
          <div class="col-12 text-center">
            <button type="button" class="btn btn-info" data-dismiss="modal">ปิด</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Modal detail-->
<div class="modal fade" id="rebateModal" tabindex="-1" role="dialog" aria-labelledby="rebateModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="rebateModalLabel">รายละเอียดเงินคืน</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-2 text-right">
            <label>ชื่อสถาบันการเงิน</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm06.bankname}}">
          </div>

          <div class="col-2 text-right">
            <label>รหัสเลขที่ของผู้ฝาก</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm06.IDNo}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>ชื่อผู้ฝาก</label>
          </div>
          <div class="col-8">
            <input type="text" class="form-control" disabled value="{{crm06.Name}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-5 text-right">
            <label>จำนวนบัญชีเงินฝาก</label>
          </div>
          <div class="col-5">
            <input type="text" class="form-control" disabled value="{{crm06.NumberOfDepositAccounts}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-5 text-right">
            <label>จำนวนบัญชีหนี้ค้างชำระ</label>
          </div>
          <div class="col-5">
            <input type="text" class="form-control" disabled value="{{crm06.NumberOfODAndDelinquentAccounts}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-5 text-right">
            <label>จำนวนบัญชีหนี้ค้างชำระ ที่ผู้ฝากเป็นผู้ค้ำประกัน</label>
          </div>
          <div class="col-5">
            <input type="text" class="form-control" disabled value="{{crm06.NumberOfGuarantee}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-5 text-right">
            <label>จำนวนบัญชีเงินฝากทั้งหมดที่ประกันสินเชื่อตนเอง</label>
          </div>
          <div class="col-5">
            <input type="text" class="form-control" disabled value="{{crm06.NumberOfAllSelfPledgedDepositAccounts}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-5 text-right">
            <label>จำนวนบัญชีเงินฝากทั้งหมดที่ประกันสินเชื่ออื่น</label>
          </div>
          <div class="col-5">
            <input type="text" class="form-control" disabled value="{{crm06.NumberOfAllDepositAccountsPledgingOther}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-5 text-right">
            <label>จำนวนบัญชีที่ถูกอายัด</label>
          </div>
          <div class="col-5">
            <input type="text" class="form-control" disabled value="{{crm06.NumberOfWithheldAccounts}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-5 text-right">
            <label>จำนวนเงินที่ได้รับจากสถาบัน</label>
          </div>
          <div class="col-5">
            <input type="text" class="form-control" disabled value="{{crm06.GrossReimbursible  | number: '.2'}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-5 text-right">
            <label>ภาษีหัก ณ ที่จ่ายดอกเบี้ยเงินฝาก</label>
          </div>
          <div class="col-5">
            <input type="text" class="form-control" disabled value="{{crm06.TaxAmount  | number: '.2'}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-5 text-right">
            <label>จำนวนเงินสุทธิที่ได้รับจากสถาบัน</label>
          </div>
          <div class="col-5">
            <input type="text" class="form-control" disabled value="{{crm06.NetReimbursible | number: '.2'}}">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>วันที่ปรับปรุงสถานะ</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="{{crm06.ModifyDate | thaidate:'short'}}">
          </div>

          <div class="col-2 text-right">
            <label>ผู้สร้างข้อมูล</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 offset-md-1 text-right">
            <label>เบอร์ที่ให้ไว้กับสถาบันการเงิน</label>
          </div>
          <div class="col-2">
            <input type="text" class="form-control" [(ngModel)]="telephoneOtp">
          </div>
          <div class="col-2">
            <button class="btn btn-primary w-100" (click)="requestOtp()" [disabled]="disableResentOtp">
              Send OTP {{requestOtpLbl}} {{otpTimer == 0 ? "" : otpTimer}}
            </button>
          </div>
          <div class="col-4 input-group my-auto">
            <label style="font-size: 1.2rem;">OTP Ref:</label>
            <label style="font-size: 1.2rem;" class="text-danger">
              {{otpRef}}
            </label>
            <label class="ml-3">Password:</label>
            <input type="text" class="form-control" [(ngModel)]="verifyOtp">
            <button class="btn btn-primary" (click)="verify()" [disabled]="verifyOtp.trim().length == 0">
              Verify {{OTPCountDown}}
            </button>
          </div>
        </div>

        <!-- <div class="row mt-3"> -->
        <!-- <div class="col-2 offset-md-1">
            <input type="text" class="form-control" value="0898871234">
          </div>
          <div class="col-2">
            <button class="btn btn-primary w-100">Send OTP</button><br>
            <label class="text-primary">* เบอร์ที่ให้ไว้กับสถาบันการเงิน</label>
          </div> -->

        <!-- <div class="col-5 input-group my-auto">
            <label style="font-size: 1.2rem;">OTP Ref.ID:</label>
            <label style="font-size: 1.2rem;" class="text-danger">AFTX</label>
            <label class="ml-3">Password:</label>
            <input type="text" class="form-control" value="">
          </div> -->

        <!-- </div> -->

        <div class="row mt-5 mb-2">
          <div class="col-12 text-center">
            <button type="button" class="btn btn-info" data-dismiss="modal">ปิด</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Modal Agent Bank Doc-->
<div class="modal fade" id="agentBankModal" tabindex="-1" role="dialog" aria-labelledby="agentBankModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="agentBankModalLabel">สถานะการยื่น Agent Bank</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-2 text-right">
            <label>ประเภทลูกค้า</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" [(ngModel)]="ag.dpa_personaltypeidname || ag.dpa_companytypeidname"
              disabled>
          </div>

          <div class="col-2 text-right">
            <label>เลขที่รับเรื่อง</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" [(ngModel)]="ag.dpa_name" disabled>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 text-right two-row-lbl">
            <label>เลขที่บัตรประชาชน/</label><br>
            <label>เลขที่พาสปอร์ต/</label><br>
            <label>เลขที่นิติบุคคล</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" [(ngModel)]="ag.dpa_idcard" disabled>
          </div>

          <div class="col-2 text-right">
            <label>สถานะยื่น</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" [(ngModel)]="ag.dpa_approvalstatusidname" disabled>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>หมายเหตุ</label>
          </div>
          <div class="col-8">
            <textarea class="form-control" rows="3" [(ngModel)]="ag.dpa_remark" disabled></textarea>
          </div>
        </div>

        <hr>
        <div class="row mt-3 mb-3 justify-content-center">
          <div class="col-8 table-responsive">
            <table id="tbDocList" style="width:100%" class="table table-bordered table-hover result-table">
              <thead>
                <tr>
                  <th></th>
                  <th>เอกสาร</th>
                </tr>
              </thead>
              <tbody>
              </tbody>
            </table>
          </div>
        </div>
        <hr>

        <div class="row mt-3">
          <div class="col-2 text-right">
            <label>หมายเลขโทรศัพท์</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" value="08595628208" disabled>
          </div>

          <div class="col-2 text-right">
            <label>วันที่สร้างข้อมูล</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" [(ngModel)]="ag.dpa_submitdateFormated" disabled>
          </div>
        </div>

        <div class="row mt-3">


          <!-- <div class="col-2 text-right">
            <label>ผู้สร้างข้อมุล</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" disabled value="Agent Bank ABC 01">
          </div> -->
        </div>

        <div class="row mt-5 mb-3">
          <div class="col-12 text-center">
            <button type="button" class="btn btn-info" data-dismiss="modal">ปิด</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/depositor-info/depositor-info.component.html